import { SelectedBaggage, SelectedBaggageItem } from '../../BaggageService/types';
import { BaggageItem, BaggageItemDirection } from '../BaggageList/types';
import { Segment, SelectedBaggageService } from '../types';
import { mergeDuplicatedTravellerServices } from '../../Checkout/utils';

export const convertBaggageOnBaggageItem = (selectedItems: SelectedBaggageItem[], segments: Segment[]): BaggageItem => {
	const directions = getDirections(selectedItems, segments);

	const mergedBaggage: SelectedBaggageItem[] = mergeDuplicatedTravellerServices(
		selectedItems,
		(item: SelectedBaggageItem) => `${item.segmentIds.toString()}`
	);
	const servicesMap = new Map(mergedBaggage.map(service => [service.baggage.allowedPassengers[0], service]));
	const totalCount = [...servicesMap.values()].reduce((count, service) => +count + +service.count, 0);

	return {
		baggage: [selectedItems[0].baggage],
		selected: true,
		priceFrom: null,
		servicesBySegments: [
			{
				count: totalCount,
				directions,
				allSegments: directions.length === segments.length,
				service: null
			}
		]
	};
};

export const getDirections = (selectedItems: SelectedBaggageItem[], segments: Segment[]): BaggageItemDirection[] => {
	const segmentIds = new Set<string>();

	selectedItems.forEach(item => {
		const segments = item.segmentIds as string[];

		segments.forEach(id => segmentIds.add(id));
	});

	const segmentRoutes: BaggageItemDirection[] = [];

	segmentIds.forEach(id => {
		const orderSegment = segments.find(segment => segment.id === id);

		if (orderSegment) {
			segmentRoutes.push({
				arrival: orderSegment.arrival.airport,
				departure: orderSegment.departure.airport
			});
		}
	});

	return segmentRoutes;
};

export const factorySelectedUpgrades = (selectedServices: SelectedBaggage[]): SelectedBaggageService[] => {
	const result: SelectedBaggageService[] = [];

	const addedKeys: Map<string, string> = new Map();

	for (const [passengerId, passengerSelectedServices] of Object.entries(selectedServices)) {
		for (const [serviceId, segments] of Object.entries(passengerSelectedServices)) {
			for (const [segmentId] of Object.entries(segments)) {
				const segmentIds = selectedServices[passengerId][serviceId][segmentId]?.segmentIds;
				const key = `${passengerId}-${serviceId}-${segmentIds.join('-')}`;

				if (!addedKeys.has(key)) {
					result.push({
						passengerId,
						segmentIds: selectedServices[passengerId][serviceId][segmentId]?.segmentIds,
						serviceId,
						count: selectedServices[passengerId][serviceId][segmentId]?.count,
						confirmedCount: selectedServices[passengerId][serviceId][segmentId]?.confirmedCount
					});

					addedKeys.set(key, key);
				}
			}
		}
	}

	return result;
};
